import { render, staticRenderFns } from "./live-broadcast-coupon.vue?vue&type=template&id=719e24a6&scoped=true&"
import script from "./live-broadcast-coupon.vue?vue&type=script&lang=js&"
export * from "./live-broadcast-coupon.vue?vue&type=script&lang=js&"
import style0 from "./live-broadcast-coupon.vue?vue&type=style&index=0&id=719e24a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719e24a6",
  null
  
)

export default component.exports